// @flow
import { handleResponseOld, makePost } from './helpers';

type PostTrackClickParams = {
    algoliaAnalytics: {
        queryId: string,
        usedIndex: string,
    },
    bidderId: number,
    deployment: string,
    itemId: number,
    position: number,
};

type PostTrackConversionParams = {
    algoliaAnalytics: {
        queryId: string,
        usedIndex: string,
    },
    bidderId: number,
    deployment: string,
    itemId: number,
};

export default {
    trackClick: ({ algoliaAnalytics, bidderId, deployment, itemId, position }: PostTrackClickParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ apiPath: 'clickconversion', deployment, path: '<SEARCH-API>' });
            request.send({
                itemId,
                position,
                queryId: algoliaAnalytics.queryId,
                usedIndex: algoliaAnalytics.usedIndex,
                userId: bidderId,
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),

    trackConversion: ({ algoliaAnalytics, bidderId, deployment, itemId }: PostTrackConversionParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ apiPath: 'clickconversion', deployment, path: '<SEARCH-API>' });
            request.send({
                itemId,
                queryId: algoliaAnalytics.queryId,
                usedIndex: algoliaAnalytics.usedIndex,
                userId: bidderId,
            });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
